import GameConfig from "../config";

function revisedRandId() {
    return Math.floor((Math.random() * 1000));
}

export default class LocalStorage {
    static isPlayerNameSet(){
        let playerName = localStorage.getItem('ChrioGamesPlayerName');
        return !!playerName;
    }

    static getPlayerName(){
        let playerName = localStorage.getItem('ChrioGamesPlayerName');
        if(!playerName) {
            playerName = `Player#${revisedRandId()}`;
            this.setPlayerName(playerName);
        }
        return playerName;
    }

    static setPlayerName(name){
        localStorage.setItem('ChrioGamesPlayerName', name);
        localStorage.setItem('ChrioGamesPlayerNameHash', revisedRandId().toString());
    }

    static getNameHash(){
        return localStorage.getItem('ChrioGamesPlayerNameHash');
    }

    static getHighscore(){
        if(window && window.localStorage){
            let highscore = [];
            try {
                highscore = JSON.parse(localStorage.getItem('FoxRunHighscore'));
            } catch(e){

            }

            if(!highscore) highscore = [];

            return highscore;
        }
    }
    static addHighscoreEntry(score, name = "Player"){
        if(window && window.localStorage) {
            let highscore = this.getHighscore();

            if(!highscore){
                highscore = [{name, score}];
            } else {
                let idx = highscore.length;
                for(let i = 0; i < highscore.length; i++) {
                    if (highscore[i].score < score && idx === highscore.length) idx = i;
                }
                highscore.splice(idx, 0, {name, score});
            }
            highscore = highscore.slice(0, GameConfig.HIGHSCORE.ENTRIES);
            localStorage.setItem('FoxRunHighscore', JSON.stringify(highscore));
        }
    }
}